<template>
<div class="with-nav-tabs">
    <nav class="border-bottom mb-3">
      <div class="container">
        <div class="compact-nav">
          <a class="button button-icon button-link menu-btn" href="/user"><span class="ico material-icons">arrow_back</span></a>
          <button class="btn btn-link ml-auto" v-if="!readonly" >OPTIES</button>
        </div>
        <div class="page-header">
          <h1 class="title" :class="{'tutorial-focus': stepcount == 5}">
            <inline-editor v-if="!readonly" :editable="sitedata.name" dbentry="name" element="normal"/>
            <span v-else>{{sitedata.name}}</span>
          </h1>
          <p class="text-muted" :class="{'tutorial-focus': stepcount == 6}"><inline-editor v-if="!readonly" :editable="sitedata.tagline" dbentry="tagline" element="textarea"/></p>
          <p class="text-muted" v-if="!readonly" >Code: <span :class="{'tutorial-focus': stepcount == 7}" >{{sitedata.websiteid}}</span> <a @click.prevent="shareModal = true" style="margin-top: -3px" href="#" class="ml-2 btn btn-link">UITDELEN</a></p>
        </div>
      </div>
    </nav>
    <div class="container">
      <button v-if="!readonly" class="btn btn-primary mb-3" @click.prevent="showModal = true"><span class="ico material-icons">add_circle</span> STAP</button>
      <ul class="item-list">
        <li v-for="(navitem, index) in nav">
          <a class="item" :href="'/'+base+'/'+websiteid+'/'+navitem.pageslug">
            
            <span class="item-image">
              <span class="number">{{index+1}}</span>
            </span>
            <span class="item-content">
              <strong class="item-title">
                  {{navitem.pagetitle}}
                  <span class="item-icons">
                    <span class="ico material-icons">arrow_forward</span>
                  </span>
              </strong>
              <span class="item-desc text-muted">
                  {{navitem.pagetext}}
              </span>
            </span>
          </a>
        </li>
      </ul>
    </div>
    <div class="nav-tabs" v-if="!readonly" >
      <a href="#" class="active">LES</a>
      <a href="#">LEERLINGEN</a>
    </div>

    <modal v-if="showModal" @close="showModal = false" title="Stap toevoegen">
        <form @submit.prevent="createPage()">
            <input-default label="Naam van stap" description="Bijv: stap 3" v-model="newpagename" capitalizeNone="none"/>
            <button class="button" type="submit">Stap toevoegen</button>
        </form>
    </modal>

    <modal v-if="askNewUserName" @close="askNewUserName = false" title="Hi">
        <form @submit.prevent="newUser()">
            <input-default label="Jouw voor- en achternaam" v-model="newusername" description="Alleen jouw leraar kan jouw naam zien" capitalizeNone="none"/>
            <input-default label="Jouw geboortedatum" v-model="newage" description="Bijv: 02-01-2002" capitalizeNone="none"/>
            <button class="button" type="submit">Doorgaan</button>
        </form>
    </modal>

    <modal v-if="enteremail" @close="enteremail = false" title="Geef je email op om door te gaan">
        <form @submit.prevent="createStudentAccount()">
            <input-default label="Jouw email" v-model="newemail" description="Alleen jouw leraar kan jouw emailadres zien. Wij delen deze emailadres verder met niemand." capitalizeNone="none"/>
            <button class="button" type="submit">Doorgaan</button>
        </form>
    </modal>

    <modal v-if="shareModal" @close="shareModal = false" title="Les uitdelen">
        <transition name="fade">
            <alert-bar v-if="copied" class="success">De link is gekopieerd. Je kunt het plakken in bijv een mailtje.</alert-bar>
        </transition>
        <div class="border-bottom" style="padding: 0 30px 0px; margin: 0 -30px 22px" v-if="false">
          <p class="text-muted">Leerlingen hoeven geen email op te geven. <a href="#">Wijzigen</a></p>
        </div>

        <a :href="'whatsapp://send?text=Ik heb de les *'+sitedata.name+'* met je gedeeld. Klik op: phable.me/lesson/'+sitedata.websiteid" class="btn btn-primary mb-2 mr-2"><span class="ml-0 ico ico-svg svg-whatsapp"></span> Deel via WhatsApp</a>
        <button class="btn btn-primary mb-2" @click.prevent="copyCode()"><span class="ml-0 ico material-icons">link</span> Link kopieren</button>

        <div class="codeInput">
          Code: <input type="text" v-model="lessonUrl" id="courseCode"/>
        </div>
    </modal>

    <transition name="fade">
      <div class="tutorial-overlay" v-if="stepcount < 9">
        <div :class="stepAlign">
          <p>{{step.msg}}</p>
          <button class="btn btn-tutorial btn-lg" @click.prevent="nextStep(stepcount+1)">Ok</button>
        </div>
      </div>
    </transition>
</div>
</template>

<script>
  import InputDefault from '../components/form/InputDefault.vue';
  import AlertBar from '../components/form/Alert.vue';
  import Loader from '../components/ui/Loader.vue';
  import Modal from '../components/modal/Modal.vue';
  import ItemAdder from '../components/app/ItemAdder.vue';
  import PageAdder from '../components/app/PageAdder.vue';
  import InlineEditor from '../components/app/InlineEditor.vue';

  import axios from 'axios';

  import { userService } from '../services/user.service.js';
  import { authHeader } from '../services/auth-header.js';

  export default {
    components: {
      InputDefault,
      InlineEditor,
      AlertBar,
      Loader,
      Modal,
      ItemAdder,
      PageAdder
    },
    created(){
    },
    props:{
      websiteid: {
        type: String
      },
      base: {
        type: String
      },
      readonly: {
        type: Boolean
      },
      creatorhome: {
        type: Boolean
      },
      creatoreditor: {
        type: Boolean
      }
    },
    data: function (){
      return {
        copied: false,
        regOption: '',
        tutorial: true,
        stepcount: '99',
        step:{msg: 'Een les bestaat uit stappen. Zoals "Week 1" of "Stap 1".'},
        stepAlign: 'alignBottom',
        msgtext: '',
        msgclass: 'error',
        showModal: false,
        shareModal: false,
        askNewUserName: false,
        enteremail: false,
        newusername: '',
        newage: '',
        newemail: '',
        username: '',
        password: '',
        submitted: false,
        loading: false,
        loggingin: false,
        newpagename: '',
        returnUrl: '',
        error: '',
        pages: {},
        mainpage: '',
        pageslug: this.$route.params.pageslug,
        mainpageid: 'home',
        pagetitle: '',
        nav: '',
        sitedata: {}
      }
    },
    computed: {
      orderedPages: function () {
        return _.orderBy(this.pages, 'order', 'desc')
      },
      lessonUrl: function () {
        return 'https://phable.me/lesson/'+this.sitedata.websiteid
      }
    },
    methods: {
        newUser(){
          if(this.sitedata.needsemail == true){
            this.enteremail = true
          } else {
            // make account
            // save local user
            // login locally
            localStorage.setItem('student', JSON.stringify(this.newusername));
            this.askNewUserName = false
          }
        },
        createStudentAccount(){
          alert('make a student account')
          // make account
          // save local user with jwt
          // enable viewing of pages and sitedata that belong to siteid by checking jwt
        },
        copyCode(){
            var copyText = document.getElementById("courseCode"); /* Get the text field */
            copyText.select(); /* Select the text field */
            copyText.setSelectionRange(0, 99999); /*For mobile devices*/
            document.execCommand("copy"); /* Copy the text inside the text field */
            this.copied = true;
        },
        toggleReadOnly(){
          this.readonly = !this.readonly
        },
        getSiteData(){
            console.log('getting site data')
            axios.get(process.env.VUE_APP_ROOT_API+'/settings/'+this.websiteid)
            .then(response => {
                this.sitedata = response.data.response

                if(JSON.parse(localStorage.getItem('user')) && JSON.parse(localStorage.getItem('user')).userId == this.sitedata.belongsto){
                  this.readonly = false;
                  console.log('is admin')
                } 
                
                if(JSON.parse(localStorage.getItem('user')) == null){
                  console.log('is not admin')
                  if(JSON.parse(localStorage.getItem('student')) == null){
                    //this.askNewUserName = true
                  }
                }
            })
        },
        getPages(){
            const pageid = ''

            if(this.$route.params.pageslug){
              //get pageid first
              this.pageid = this.mainpageid
            } else {
              this.pageid = 'home'
            }

            axios.get(process.env.VUE_APP_ROOT_API+'/pages/'+this.websiteid+'/'+this.pageid)
            .then(response => {
                this.pages = response.data.response
            })
        },
        getNav(){
            axios.get(process.env.VUE_APP_ROOT_API+'/pages/'+this.websiteid+'/home')
            .then(response => {
                this.nav = response.data.response
            })
        },
        createPage(){

            const requestOptions = {
              headers: authHeader()
            }

            const data = {
              websiteid: this.websiteid,
              belongsto: 'home',
              pagetitle: this.newpagename,
              pagetype: 'nav'
            }

            axios.post(process.env.VUE_APP_ROOT_API+'/pages/', data, requestOptions)
            .then(response => {
                this.newpagename = ''
                this.showModal = false
                this.getNav()
                console.log(response)
            })
            
        },
        nextStep(nextStepcount){
          this.stepcount = nextStepcount
          if(this.stepcount == 5){
            this.step.msg = 'Je kunt op teksten klikken om ze aan te passen.'
            this.stepAlign = 'alignBottom'
          }
          if(this.stepcount == 6){
            this.step.msg = 'Dit kan ook met beschrijvingen.'
            this.stepAlign = 'alignBottom'
          }
          if(this.stepcount == 7){
            this.step.msg = 'Geef deze code aan studenten. Hiermee kunnen ze deze les vinden.'
            this.stepAlign = 'alignBottom'
          }
          if(this.stepcount == 8){
            this.step.msg = 'Pas de titel en beschrijving aan.'
            this.stepAlign = 'alignBottom'
          }
          if(this.stepcount == 9){
            const requestOptions = {
              headers: authHeader()
            }

            const data = {
              user: JSON.parse(localStorage.getItem('user')).userId,
              step: 9,
            }

            axios.patch(process.env.VUE_APP_ROOT_API+'/users/step', data, requestOptions)
            .then(response => {
                console.log(response)
            })

            const placeholder = JSON.parse(localStorage.getItem('user'))
            placeholder['tourStep'] = 9;

            localStorage.setItem('user', JSON.stringify(placeholder));
            this.tutorial = false
          }
        },
    },
    mounted(){
        this.getPages()
        this.getSiteData()
        this.getNav()

        if(JSON.parse(localStorage.getItem('user'))){
          this.stepcount = JSON.parse(localStorage.getItem('user')).tourStep
        }
    }
  }
</script>